import designIcon from "../../images/hireDeveloper/designIcon.svg";
import developmentIcon from "../../images/hireDeveloper/developmentIcon.svg";
import marketingIcon from "../../images/hireDeveloper/marketingIcon.svg";

export const roleHead = [
  {
    id: "mobile",
    images: designIcon,
    label: "Mobile Development",
    subData: [
      "Xamarin Specialist",
      "React Native Specialist",
      "Android Specialist",
      "iOS Specialist",
      "Flutter Specialist",
    ],
  },
  {
    id: "frontend",
    images: designIcon,
    label: "Frontend Development",
    subData: [
      "Angular Specialist",
      "React.js Specialist",
      "Nuxt.js Specialist",
      "Vue.js Specialist",
      "Javascript Specialist",
    ],
  },
  {
    id: "backend",
    images: developmentIcon,
    label: "Backend Development",
    subData: [
      "Node.js Specialist",
      ".NET Core Specialist",
      "Laravel Specialist",
      "Python Specialist",
      "Java Specialist",
    ],
  },
  {
    id: "cloud",
    images: marketingIcon,
    label: "Cloud Service",
    subData: [
      "Amazon Web Services (AWS)",
      "Microsoft Azure",
      "Google Cloud",
      "DigitalOcean Cloud",
    ],
  },
];
